import ReactGA from 'react-ga4';

const intializeAnalytics = () =>{
    ReactGA.initialize('G-NNRZ97PNMH');
}

export default intializeAnalytics;
